import { render, staticRenderFns } from "./AdminDPWList.vue?vue&type=template&id=4bf4a185"
import script from "./AdminDPWList.vue?vue&type=script&lang=js"
export * from "./AdminDPWList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports